const randomChartOption = {
  title: {show: false},
  color: "#E6A23C",
  tooltip: {
    trigger: 'axis',
    triggerOn: 'click',
    axisPointer: {
      type: 'shadow'
    },
    enterable: true,
    confine: true
  },
  grid: {
    top: 15,
    bottom: 20
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    nameTextStyle: {
      color: '#666666'
    },
    axisLabel: {
      show: true,
      showMinLabel: true,
      fontSize: 10
    },
    axisLine: {
      show: true,
      lineStyle: {
        width: 0.5,
        color: '#999999',
        shadowColor: '#fff',
        shadowBlur: 10
      }
    },
    axisTick: {
      show: true,
      inside: true,
      length: 5,
      lineStyle: {
        width: 0.5,
        color: '#999999',
        shadowColor: '#fff',
        shadowBlur: 10
      }
    },
    data: []
  },
  yAxis: {
    type: 'value',
    offset: 0,
    nameTextStyle: {
      color: '#666666'
    },
    axisLabel: {
      show: true,
      showMinLabel: true,
      fontSize: 10
    },
    axisLine: {
      show: false
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: '#e5e5e5',
        type: 'dotted'
      }
    },
    axisTick: {
      show: false
    }
  },
  series: [{
      lineStyle: {
        color: '#E6A23C',
        width: 2
      },
      nameTextStyle: {
        color: 'red'
      },
      label: {
        color: 'auto'
      },
      name: '预期值',
      data: [],
      type: 'line',
      smooth: true,
      showSymbol: false,
      hoverAnimation: true
    }
  ]
}

const predictChartOption = {
  title: {show: false},
  color: "#67C23A",
  tooltip: {
    trigger: 'axis',
    triggerOn: 'click',
    axisPointer: {
      type: 'shadow'
    },
    enterable: true,
    confine: true
  },
  grid: {
    top: 15,
    bottom: 20
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    nameTextStyle: {
      color: '#666666'
    },
    axisLabel: {
      show: true,
      showMinLabel: true,
      fontSize: 10
    },
    axisLine: {
      show: true,
      lineStyle: {
        width: 0.5,
        color: '#999999',
        shadowColor: '#fff',
        shadowBlur: 10
      }
    },
    axisTick: {
      show: true,
      inside: true,
      length: 5,
      lineStyle: {
        width: 0.5,
        color: '#999999',
        shadowColor: '#fff',
        shadowBlur: 10
      }
    },
    data: []
  },
  yAxis: {
    type: 'value',
    offset: 0,
    nameTextStyle: {
      color: '#666666'
    },
    axisLabel: {
      show: true,
      showMinLabel: true,
      fontSize: 10
    },
    axisLine: {
      show: false
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: '#e5e5e5',
        type: 'dotted'
      }
    },
    axisTick: {
      show: false
    }
  },
  series: [{
    lineStyle: {
      color: '#67C23A',
      width: 2
    },
    nameTextStyle: {
      color: 'red'
    },
    label: {
      color: 'auto'
    },
    name: '预期值',
    data: [],
    type: 'line',
    smooth: true,
    showSymbol: false,
    hoverAnimation: true
  }
  ]
}

export {
  predictChartOption,
  randomChartOption
}
